/**
 * The operator glyphs that are plain text too, so they are offered inside a unit bracket and never
 * autocomplete the input the way a math operator does.
 */
export const TEXT_SYMBOLS = [
  ",",
  ".",
  "-",
  "\\",
  "/",
  "|",
  "!",
  "*",
  "'",
  '"',
  ";",
  ":",
  "<",
  ">",
  "⋅",
];

function getAutocompleteRegex(symbol: string): string {
  return `^${symbol.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}.?$`;
}

/**
 * The default autocomplete rule of an operator symbol: typing the glyph, with at most one
 * character after it, completes to the symbol; none for the text symbols.
 */
export function getAutocompleteProps(symbol: string) {
  if (TEXT_SYMBOLS.includes(symbol)) {
    return undefined;
  }

  return {
    math: { regex: getAutocompleteRegex(symbol) },
    text: { regex: getAutocompleteRegex(symbol) },
  };
}
